<template>
  <div>
    <div class="exh-title homeTipsTitle">
      {{ $t('homes.featuredExhibitors') }}
    </div>
    <div class="text-right home-max-width theme-color margin-b-8">
      <span class=" pointer" @click="cb({'type':'refresh','data':''})">
        <span class="iconfont iconswitch-camera-"></span>
        <span>{{ $t('change') }}</span>
      </span>
    </div>
    <div class="exhFeatured flex-start">
      <div class="exh-featured-item" v-for="(item, index) in exhFeatured" :key="index" @click="pageDetail(item, 'actor', true, 'featured')">
        <img v-if="!item.advertsImage" src="../../assets/images/product2.png" class="auto-img" />
        <img v-if="item.advertsImage" v-lazy="$funcs.compressImage(item.advertsImage.split(',')[0])" class="auto-img lazy-img-fadein" />
        <div class="exh-item-shadow font-size-16">
          <img v-if="!item.logoImage" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/exhLogo.png" class="logo-img" />
          <img v-if="item.logoImage" v-lazy="$funcs.compressImage(item.logoImage)" class="logo-img lazy-img-fadein" />
          <p>{{ language == 'en' ? item.enName : item.name }}</p>
          <!-- <p>{{ item.exhibitionBoothNumber }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    exhFeatured: {
      type: [Object, String, Array],
      default: () => []
    },
    language: {
      type: [String],
      default: () => 'en'
    }
  },
  methods:{
    cb(param){
      this.$emit('callback',param)
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  created() {}
}
</script>

<style lang="stylus" scoped>
.home-max-width{
  width:100%;
  max-width:1366px;
  margin:0 auto;
  padding:0 14px;
}
.exhFeatured{
  width:100%;
  max-width:1336px;
  margin:0px auto 80px;
  flex-wrap:wrap;
  .exh-featured-item{
    width: 217.66666666666666px;
    height: 217.66666666666666px;
    margin:3px;
    cursor:pointer;
    position:relative;

    &:nth-child(6n + 1) {
      margin-left: 0
    }
    &:nth-child(6n) {
      margin-right: 0
    }
    
    .exh-item-shadow{
      position:absolute;
      width:100%;
      height:100%;
      top:0;
      left:0;
      background:$color-black-65;
      text-align:center;
      color:#fff;
      padding-top:40px;
      transition all .3s
      .logo-img{
        width:80px;
        height:80px;
        border-radius:50%;
        object-fit contain;
        background $color-white;
      }

      &:hover {
        background: $color-black-85
      }
    }
    .auto-img{
      width:100%;
      height:100%;
      object-fit cover
    }
  }
}
</style>
